<template>
  <div class="top-action-bar">
    <div class="action-bar-left">
      <button
        class="action-bar-btn filters-btn"
        :class="{ 'has-filters': activeFiltersCount > 0 }"
        @click="$emit('toggle-filters')"
      >
        <feather-icon icon="FilterIcon" size="14" />
        <span>Filtros</span>
        <span v-if="activeFiltersCount > 0" class="filter-badge">{{ activeFiltersCount }}</span>
      </button>

      <div class="tabs-segmented">
        <button
          class="tab-seg-btn"
          :class="{ active: activeTab === 0 }"
          :disabled="isLoading"
          @click="$emit('change-tab', 0)"
        >
          <span>Pedidos</span>
          <span class="tab-count" v-if="totalPedidos > 0">{{ formatCount(totalPedidos) }}</span>
        </button>
        <button
          class="tab-seg-btn"
          :class="{ active: activeTab === 1 }"
          :disabled="isLoading"
          @click="$emit('change-tab', 1)"
        >
          <span>Rascunhos</span>
          <span class="tab-count" v-if="totalRascunhos > 0">{{ formatCount(totalRascunhos) }}</span>
        </button>
      </div>
    </div>

    <div class="action-bar-right">
      <div class="per-page-control">
        <label class="per-page-label">Exibir:</label>
        <select
          class="per-page-select"
          :value="pageSize"
          @change="$emit('change-page-size', parseInt($event.target.value))"
        >
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>

      <div class="view-toggle">
        <button
          v-for="view in views"
          :key="view.id"
          class="view-btn"
          :class="{ active: currentView === view.id }"
          :title="view.label"
          @click="$emit('change-view', view.id)"
        >
          <feather-icon :icon="view.icon" size="14" />
        </button>
      </div>

      <button
        class="action-bar-btn primary-btn"
        @click="$emit('new-order')"
      >
        <feather-icon icon="PlusIcon" size="14" />
        <span class="btn-text">Novo Pedido</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopActionBar',
  props: {
    currentView: {
      type: String,
      default: 'list',
    },
    activeFiltersCount: {
      type: Number,
      default: 0,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    totalPedidos: {
      type: Number,
      default: 0,
    },
    totalRascunhos: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      views: [
        { id: 'list', icon: 'ListIcon', label: 'Lista' },
        { id: 'kanban', icon: 'TrelloIcon', label: 'Kanban' },
        { id: 'cards', icon: 'GridIcon', label: 'Cards' },
      ],
    };
  },
  methods: {
    formatCount(count) {
      if (count >= 10000) {
        return `${Math.floor(count / 1000)}k`;
      }
      return count.toLocaleString('pt-BR');
    },
  },
};
</script>

<style scoped>
.top-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  margin-bottom: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.action-bar-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.action-bar-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.action-bar-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.625rem;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  height: 32px;
}

.filters-btn {
  background: var(--surface-bg, #f8fafc);
  color: var(--text-secondary, #64748b);
  border: 1px solid var(--border-color, #e5e7eb);
}

.filters-btn:hover {
  background: var(--hover-bg, #f1f5f9);
  color: var(--text-primary, #1e293b);
}

.filters-btn.has-filters {
  background: rgba(99, 102, 241, 0.08);
  color: #6366f1;
  border-color: rgba(99, 102, 241, 0.3);
}

.filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  font-size: 0.625rem;
  font-weight: 600;
  background: #6366f1;
  color: #ffffff;
  border-radius: 100px;
}

.tabs-segmented {
  display: flex;
  background: var(--surface-bg, #f1f5f9);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  padding: 2px;
}

.tab-seg-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary, #64748b);
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  height: 26px;
}

.tab-seg-btn:hover:not(:disabled) {
  color: var(--text-primary, #1e293b);
}

.tab-seg-btn.active {
  background: var(--card-bg, #ffffff);
  color: #6366f1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.tab-seg-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;
  padding: 0 4px;
  font-size: 0.625rem;
  font-weight: 600;
  background: rgba(100, 116, 139, 0.15);
  color: var(--text-secondary, #64748b);
  border-radius: 100px;
}

.tab-seg-btn.active .tab-count {
  background: rgba(99, 102, 241, 0.15);
  color: #6366f1;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.per-page-label {
  font-size: 0.75rem;
  color: var(--text-muted, #94a3b8);
  margin: 0;
}

.per-page-select {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  color: var(--text-primary, #1e293b);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 4px;
  cursor: pointer;
  height: 26px;
}

.per-page-select:focus {
  outline: none;
  border-color: #6366f1;
}

.view-toggle {
  display: flex;
  background: var(--surface-bg, #f1f5f9);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  padding: 2px;
}

.view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 26px;
  background: transparent;
  color: var(--text-muted, #94a3b8);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.view-btn:hover {
  color: var(--text-secondary, #64748b);
}

.view-btn.active {
  background: var(--card-bg, #ffffff);
  color: #6366f1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.primary-btn {
  background: #6366f1;
  color: #ffffff;
  border: none;
}

.primary-btn:hover {
  background: #4f46e5;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.25);
}

@media (max-width: 1024px) {
  .per-page-control {
    display: none;
  }
}

@media (max-width: 768px) {
  .top-action-bar {
    flex-wrap: wrap;
    padding: 0.5rem;
  }

  .action-bar-left {
    width: 100%;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .action-bar-right {
    width: 100%;
    justify-content: space-between;
  }

  .btn-text {
    display: none;
  }

  .primary-btn {
    padding: 0.375rem 0.5rem;
  }

  .tabs-segmented {
    order: -1;
    width: 100%;
    justify-content: center;
  }

  .tab-seg-btn {
    flex: 1;
    justify-content: center;
  }
}

body.dark-layout .top-action-bar {
  background: var(--dark-card-bg, #283046);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .filters-btn {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .filters-btn:hover {
  background: var(--dark-hover-bg, #2d3548);
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .tabs-segmented {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .tab-seg-btn {
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .tab-seg-btn:hover:not(:disabled) {
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .tab-seg-btn.active {
  background: var(--dark-card-bg, #283046);
  color: #818cf8;
}

body.dark-layout .tab-count {
  background: rgba(129, 140, 248, 0.15);
}

body.dark-layout .per-page-select {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .view-toggle {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .view-btn {
  color: var(--dark-text-muted, #676d7d);
}

body.dark-layout .view-btn.active {
  background: var(--dark-card-bg, #283046);
  color: #818cf8;
}

body.dark-layout .primary-btn {
  background: #6366f1;
}

body.dark-layout .primary-btn:hover {
  background: #4f46e5;
}
</style>
